import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "input", "submitBtn"]

  improve(event) {
    const mode = event.currentTarget.dataset.mode
    const confirmMessage = event.currentTarget.dataset.confirm

    if (confirmMessage && !confirm(confirmMessage)) {
      return
    }

    // Блокируем кнопки
    const buttons = this.element.querySelectorAll('button')
    buttons.forEach(btn => {
      btn.disabled = true
      btn.classList.add('opacity-50', 'pointer-events-none')
    })

    // Обновляем action формы и отправляем
    this.formTarget.action = window.location.pathname + '/improve?mode=' + mode
    this.formTarget.requestSubmit()
  }
}
